import { useMutation, useQueryClient } from 'react-query'
import usersApi from './actions'
import { usersKeys } from './constants'

export const useUsersMutations = (companyId?: number) => {
  const queryClient = useQueryClient()

  const createUser = useMutation(usersApi.createUser, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(usersKeys.root(companyId))
    },
  })

  const updateUser = useMutation(usersApi.updateUser, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(usersKeys.root(companyId))
    },
  })

  const deleteUser = useMutation(usersApi.deleteUser, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(usersKeys.root(companyId))
    },
  })

  const updateUserFeatures = useMutation(usersApi.updateUserFeatures, {
    onSuccess: async ({ userId }) => {
      await queryClient.invalidateQueries(usersKeys.userFeatures(userId))
    },
    onMutate: () => {},
    onSettled: () => {},
  })

  return { createUser, updateUser, deleteUser, updateUserFeatures }
}

export default useUsersMutations
